module.exports = __webpack_public_path__ + "img/s7Model5B.3f05af63.webp";